// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1f120271","703":"f0e21970","787":"e72a5fdf"}[chunkId] + ".chunk.js";
};